'use client'

import { useEffect } from 'react'
import { getDataLayer } from '@/hooks/use-tracker'

export const Tracking = () => {
  useEffect(() => {
    let lastReceivedMessage = null
    const url = location.href
    let urlWithoutParams = url.split('?')[0]
    if (urlWithoutParams.endsWith('/')) {
      urlWithoutParams = urlWithoutParams.slice(0, -1)
    }

    const handler = (event: MessageEvent<any>) => {
      if (
        lastReceivedMessage &&
        JSON.stringify(lastReceivedMessage) === JSON.stringify(event.data)
      ) {
        return
      }
      lastReceivedMessage = event.data
      switch (event.data.event) {
        case 'plainer_content_view_start': {
          try {
            getDataLayer().push({
              event: 'demo_start',
              demo_id: event.data.contentId,
              demo_duration: event.data.contentTotalSteps
            })
          } catch (e) {
            // NOP
          }
          break
        }
        case 'plainer_content_operate_start': {
          try {
            ;(window as Window & { piTracker?: any }).piTracker(
              urlWithoutParams + '/demo_start/' + event.data.contentId
            )
          } catch (e) {
            // NOP
          }
          break
        }
        case 'plainer_guide_view_complete': {
          try {
            getDataLayer().push({
              event: 'demo_complete',
              demo_id: event.data.contentId,
              demo_duration: event.data.contentTotalSteps
            })
            ;(window as Window & { piTracker?: any }).piTracker(
              urlWithoutParams + '/demo_complete/' + event.data.contentId
            )
          } catch (e) {
            // NOP
          }
          break
        }
        case 'plainer_guide_view_start': {
          try {
            getDataLayer().push({
              event: 'demo_progress',
              demo_id: event.data.contentId,
              demo_duration: event.data.contentTotalSteps,
              demo_current_step: event.data.contentCurrentStep
            })
          } catch (e) {
            // NOP
          }

          break
        }
        default:
          break
      }
    }

    window.addEventListener('message', handler)

    return () => {
      window.removeEventListener('message', handler)
    }
  }, [])

  return null
}
